import axiosInstance from "../axiosInstance";

export const categoryService = {
  create: async (data) => {
    try {
      const response = await axiosInstance.post("/category", data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  fetch: async (searchValue, client_id, select = [], query = "") => {
    try {
      let api = `/category?`;
      if (searchValue) api += `&name[$search]=${searchValue}`;
      if (client_id) api += `&client=${client_id}`;
      if (select.length) api += select.map((s) => `&$select[]=${s}`).join("");
      if (query) api += `&${query}`;
      const response = await axiosInstance.get(api);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Fetch root-level categories (no parent) with pagination + filter support
  fetchRoots: async (searchValue, query, client_id) => {
    try {
      let api = `/category?parent=null`;
      if (client_id) api += `&client=${client_id}`;
      if (searchValue?.trim()) api += `&name[$search]=${searchValue.trim()}`;
      if (query?.length) api += `&${query}`;
      if (!query || !query.includes("$sort")) api += `&$sort[name]=1`;
      const response = await axiosInstance.get(api);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Fetch direct children of a given parent id
  fetchByParent: async (parentId, client_id) => {
    try {
      let api = `/category?parent=${parentId}&$limit=500&$sort[name]=1`;
      if (client_id) api += `&client=${client_id}`;
      const response = await axiosInstance.get(api);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  fetchNames: async (
    searchKey,
    client_id,
    limit = 15,
    skip = 0,
    excludeIds = [],
  ) => {
    try {
      let api = `/category?$limit=${limit}&$skip=${skip}&$select[]=name&$sort[name]=1`;
      if (client_id) api += `&client=${client_id}`;
      if (searchKey) api += `&name[$search]=${searchKey}`;
      if (excludeIds.length)
        api += excludeIds.map((x) => `&_id[$nin]=${x}`).join("");
      const response = await axiosInstance.get(api);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  edit: async (data, id) => {
    try {
      const response = await axiosInstance.patch(`/category/${id}`, data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  delete: async (id) => {
    try {
      const response = await axiosInstance.delete(`/category/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};
